module.exports = __webpack_public_path__ + "static/media/franchising-small.62da00e5.webp";